import { useState } from "react"
import styled, { keyframes } from "styled-components"
import tw from "twin.macro"

import useParksWA from "lib/useParksWA"

import { AlertProps } from "components/dynamic"
import Section from "components/Section"
import InfoIcon from "icons/Info"
import CaretDown from "icons/CaretDown"

const FadeIn = keyframes`
0% {
  opacity: 0;
}
100% {
  opacity: 1;
}
`

const AlertWrapper = styled.div.attrs(() => ({
  role: "alert",
}))`
  ${tw`px-5 py-7 rounded-xl border-solid border`}
  border-color: #efb43e;
  background-color: #fdf7ec;
  animation: ${FadeIn} 0.4s;
`

const Alert = ({ EmergencyWAParkID }: AlertProps) => {
  const parksData = useParksWA(EmergencyWAParkID)
  const [alertsOpen, setAlertsOpen] = useState(false)
  return parksData && parksData.length > 0 ? (
    <Section>
      <AlertWrapper>
        <div tw="flex items-center">
          <InfoIcon tw="flex-shrink-0 w-5 h-5 mr-4" />
          <div tw="flex-grow">
            {parksData?.length} active{" "}
            {parksData.length > 1 ? "alerts" : "alert"} found for this location
          </div>
          {parksData?.length > 0 && (
            <button
              type="button"
              tw="flex-shrink-0 px-2"
              onClick={() => setAlertsOpen(!alertsOpen)}
            >
              <CaretDown tw="w-4 h-4" />
            </button>
          )}
        </div>
        <div hidden={!alertsOpen}>
          <ul tw="mt-3 pl-9 mb-0 max-w-prose">
            {parksData?.map((alert, idx) => (
              // eslint-disable-next-line react/no-array-index-key
              <li key={idx} tw="mt-2">
                <strong tw="block">{alert.Title}</strong>
                {/* eslint-disable-next-line react/jsx-no-target-blank */}
                {alert.Description.replace(/(<([^>]+)>)/gi, "")}
              </li>
            ))}
          </ul>
        </div>
      </AlertWrapper>
    </Section>
  ) : null
}

export default Alert
